import { memo } from "react";

import type { LangCode, PlanI18n_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { MagazineEditor } from "../../../../_shared/ui/component/editor/magazine-editor";
import { DesignMagazineHeaderRightChildren } from "../../../../_shared/ui/component/header/right-children";
import { getMagazineEditPageUrl } from "../../../../_shared/utils/get-magazine-edit-page-url";
import { useInitialized } from "../../model/usecase/use-initialized";

type Props = {
	hotelID: string;
	planID: string;
	langCode: LangCode;
	data: PlanI18n_DesignPageQuery;
};

export const DesignMagazinePlanArticleI18nEditPresenter = memo(({ hotelID, planID, langCode, data }: Props) => {
	const { articleHTML, serverModel, isValid, isDirty, onUpdate, onSetArticleHTML } = useInitialized({
		hotelID,
		planID,
		langCode,
		serverModel: data,
	});
	const { name } = serverModel.planI18n;

	useTransitionBlock(isDirty);

	return (
		<div>
			<FeatureIslandHeader
				title="プラン記事の編集"
				activeLangCode={langCode}
				navigator={{
					default: getMagazineEditPageUrl({
						hotelID,
						magazineResourceID: planID,
						magazineResourceType: "Plan",
					}),
					i18n: (lang) =>
						getMagazineEditPageUrl({
							hotelID,
							magazineResourceID: planID,
							magazineResourceType: "Plan",
							langCode: lang,
						}),
				}}
				rightChildren={<DesignMagazineHeaderRightChildren isValid={isValid} onUpdate={onUpdate} />}
			/>

			{Boolean(articleHTML) && (
				<MagazineEditor
					resourceName={name}
					tiptapEditorProps={{
						content: articleHTML,
						hotelID,
						handleEditorContentChange: onSetArticleHTML,
					}}
				/>
			)}
		</div>
	);
});

DesignMagazinePlanArticleI18nEditPresenter.displayName = "DesignMagazinePlanArticleI18nEdit";
